import React from "react";

import { MainMenu } from "@excalidraw/excalidraw/index";
import {
  useExcalidrawAPI,
  useExcalidrawSetAppState,
} from "@excalidraw/excalidraw/components/App";
import {
  EmbedIcon,
  frameToolIcon,
  laserPointerToolIcon,
  mermaidLogoIcon,
  TrashIcon,
} from "@excalidraw/excalidraw/components/icons";
import { activeConfirmDialogAtom } from "@excalidraw/excalidraw/components/ActiveConfirmDialog";
import { useSetAtom } from "@excalidraw/excalidraw/editor-jotai";
import { useI18n } from "@excalidraw/excalidraw/i18n";

import type { Theme } from "@excalidraw/element/types";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  refresh: () => void;
}> = React.memo((props) => {
  const { t } = useI18n();
  const setAppState = useExcalidrawSetAppState();
  const excalidrawAPI = useExcalidrawAPI();
  const setActiveConfirmDialog = useSetAtom(activeConfirmDialogAtom);

  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      <MainMenu.Item
        icon={mermaidLogoIcon}
        onSelect={() =>
          setAppState({ openDialog: { name: "ttd", tab: "mermaid" } })
        }
      >
        {t("toolBar.mermaidToExcalidraw")}
      </MainMenu.Item>
      <MainMenu.Item
        icon={laserPointerToolIcon}
        onSelect={() => excalidrawAPI?.setActiveTool({ type: "laser" })}
      >
        {t("toolBar.laser")}
      </MainMenu.Item>
      <MainMenu.Item
        icon={frameToolIcon}
        onSelect={() => excalidrawAPI?.setActiveTool({ type: "frame" })}
      >
        {t("toolBar.frame")}
      </MainMenu.Item>
      <MainMenu.Item
        icon={EmbedIcon}
        onSelect={() => excalidrawAPI?.setActiveTool({ type: "embeddable" })}
      >
        {t("toolBar.embeddable")}
      </MainMenu.Item>
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      {/*<MainMenu.DefaultItems.CommandPalette className="highlighted" />*/}
      <MainMenu.DefaultItems.SearchMenu />
      {/*<MainMenu.DefaultItems.Preferences />*/}
      <MainMenu.DefaultItems.Help />
      {/* Explicit always-visible item: the stock DefaultItems.ClearCanvas is
          gated by an action predicate; this replacement is shown in every mode
          (incl. live collaboration) and opens the same confirm dialog. */}
      <MainMenu.Item
        icon={TrashIcon}
        onSelect={() => setActiveConfirmDialog("clearCanvas")}
      >
        {t("buttons.clearReset")}
      </MainMenu.Item>
      <MainMenu.Separator />
      <MainMenu.DefaultItems.ChangeCanvasBackground />
    </MainMenu>
  );
});
